<template>
  <div class="login-container">
    <div class="login-form">
      <h2>博客管理后台</h2>
      <el-tabs v-model="activeTab" class="login-tabs">
        <el-tab-pane label="密码登录" name="password">
          <el-form :model="form" ref="form" label-width="80px">
            <el-form-item label="用户名" prop="username">
              <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input type="password" v-model="form.password" placeholder="请输入密码" @keyup.enter.native="login"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="login" style="width: 100%">登录</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="钉钉登录" name="dingtalk">
          <div class="dingtalk-login">
            <p class="dingtalk-desc">使用钉钉账号登录管理后台</p>
            <el-button type="primary" class="dingtalk-btn" @click="dingtalkLogin" :loading="dingtalkLoading">
              <svg class="dingtalk-icon" viewBox="0 0 1024 1024" width="20" height="20">
                <path fill="currentColor" d="M675.2 275.2c22.4-22.4 22.4-57.6 0-80s-57.6-22.4-80 0l-121.6 121.6c-22.4 22.4-22.4 57.6 0 80l121.6 121.6c22.4 22.4 57.6 22.4 80 0s22.4-57.6 0-80L553.6 396.8l121.6-121.6zM473.6 473.6l-121.6-121.6c-22.4-22.4-57.6-22.4-80 0s-22.4 57.6 0 80l121.6 121.6L272 675.2c-22.4 22.4-22.4 57.6 0 80 22.4 22.4 57.6 22.4 80 0l121.6-121.6 121.6 121.6c22.4 22.4 57.6 22.4 80 0s22.4-57.6 0-80L473.6 473.6z"/>
              </svg>
              钉钉扫码登录
            </el-button>
            <div class="dingtalk-tip">
              <span>点击按钮后将跳转到钉钉授权页面，使用钉钉 App 扫码即可登录</span>
            </div>
            
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getDingTalkAuthUrl, loginUser } from '@/api/blog'

export default {
  name: 'Login',
  data() {
    return {
      activeTab: 'password',
      dingtalkLoading: false,
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    async login() {
      try {
        const res = await loginUser({ 
          email: this.form.username, 
          password: this.form.password 
        })
        const data = res.data
        if (data.success) {
          sessionStorage.setItem('admin_logged', 'true')
          sessionStorage.setItem('admin_token', data.token)
          sessionStorage.setItem('admin_user', JSON.stringify({
            nick: data.nickname,
            avatarUrl: '',
            id: data.id
          }))
          this.$router.push('/admin')
        } else {
          this.$message.error(data.message || '登录失败')
        }
      } catch (e) {
        this.$message.error('登录请求失败')
      }
    },
    async dingtalkLogin() {
      this.dingtalkLoading = true
      try {
        const res = await getDingTalkAuthUrl()
        window.location.href = res.data.url
      } catch (e) {
        this.$message.error('获取钉钉授权链接失败')
        this.dingtalkLoading = false
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-form {
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  width: 400px;
}

.login-form h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

.login-tabs {
  margin-top: 10px;
}

.login-tabs .el-tabs__header {
  margin-bottom: 20px;
}

.dingtalk-login {
  text-align: center;
  padding: 20px 0;
}

.dingtalk-desc {
  color: #666;
  margin-bottom: 24px;
  font-size: 14px;
}

.dingtalk-btn {
  width: 220px;
  height: 44px;
  font-size: 16px;
  background: #1890ff;
  border-color: #1890ff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.dingtalk-btn:hover {
  background: #40a9ff;
  border-color: #40a9ff;
}

.dingtalk-icon {
  vertical-align: middle;
}

.dingtalk-tip {
  margin-top: 16px;
  font-size: 12px;
  color: #999;
}
</style>
